const dataWasteRecycle = [
  {
    title: "Sampah yang dapat didaur ulang",
    content:
      "Sampah yang dapat didaur ulang adalah sampah yang dapat digunakan kembali atau diubah menjadi bentuk lain. Bahan yang dapat didaur ulang adalah kaca, plastik, kertas, logam, tekstil dan bahan lainnya",
  },
  {
    title: "Sampah yang tidak dapat didaur ulang",
    content:
      "Sampah yang tidak dapat didaur ulang adalah sampah yang tidak dapat digunakan kembali dan tidak dapat diubah menjadi bentuk lain. tisu, popok bekas, styrofoam, cermin, bola lampu, keramik pecah,  sampah elektronik dan lain-lain. ",
  },
];

export default dataWasteRecycle;
